<div class="layout-menu-wrapper" role="sidenav" [ngClass]="{'layout-menu-wrapper-active': app.menuActive}" (click)="onMenuClick()">
    <p-scrollPanel #layoutMenuScroller [style]="{height: '100%'}">
        <div class="layout-menu-container">
            <ul app-submenu [item]="app.model" root="true" class="layout-menu" visible="true" [reset]="reset"
                parentActive="true"></ul>
        </div>
    </p-scrollPanel>
</div>
